<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Calendar</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <full-calendar id="calendar" :events="events" :config="config" ref="calendar"></full-calendar>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import { FullCalendar } from 'vue-full-calendar';
    import 'fullcalendar/dist/fullcalendar.css';
    import BackendFooter from '@/components/backend/partials/footer';
    import { Modal } from 'bootstrap-vue/es/components';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,
            'full-calendar': FullCalendar,
        },
        data() {
            return {
                selected:"",
                events: [
                            {
                                "title":"Test",
                                "start":"2018-12-24T04:18:00",
                                "end":"2019-04-30T15:50:31",
                                "eventdate":"12\/24\/2018",
                                "eventtime":"04:18AM",
                                "id":5,
                                "description":"Des",
                                "duration":3,
                                "location_id":"0",
                                "contact_person":"ADBSE",
                                "contact_email":"tirthraj@savitriya.com",
                                "contact_number":"9876543210",
                                "scheduled_for":0,
                                "role_name":"All",
                                "status":"active",
                                "type":"normal",
                                "created_at":"2018-11-01 05:21:56",
                                "updated_at":"2018-12-19 21:24:38",
                                "wellness_id":null,
                                "wellness_title":""
                            },
                            {
                                "title":"Normal Event",
                                "start":"2018-12-22T11:50:33",
                                "end":"2019-04-01T12:50:33",
                                "eventdate":"12\/22\/2018",
                                "eventtime":"11:50AM",
                                "id":12,
                                "description":"Normal Event Description",
                                "duration":2,
                                "location_id":"0",
                                "contact_person":"DEMO DEMO",
                                "contact_email":"demo@demo.com",
                                "contact_number":"9876543210",
                                "scheduled_for":0,
                                "role_name":"All",
                                "status":"active",
                                "type":"normal",
                                "created_at":"2018-12-20 22:21:17",
                                "updated_at":"2018-12-20 22:21:17",
                                "wellness_id":1,
                                "wellness_title":"Accessible AetnaGet Active Program"
                            },
                            {
                                "title":"Time Zone PST8PDT",
                                "start":"2019-03-15T18:12:00",
                                "end":"2019-03-31T18:12:00",
                                "eventdate":"03\/15\/2019",
                                "eventtime":"18:12PM",
                                "id":30,
                                "description":"Descriptio ",
                                "duration":0,
                                "location_id":"0",
                                "contact_person":null,
                                "contact_email":"",
                                "contact_number":"",
                                "scheduled_for":0,
                                "role_name":"All",
                                "status":"active",
                                "type":"normal",
                                "created_at":"2019-03-15 04:43:11",
                                "updated_at":"2019-03-15 04:43:11",
                                "wellness_id":null,
                                "wellness_title":""
                            },
                            {
                                "title":"Recursive Monthly",
                                "start":"2019-04-02T11:52:00",
                                "end":"2019-04-02T12:52:00",
                                "eventdate":"2nd To 2nd Of Every Month",
                                "eventtime":"",
                                "id":13,
                                "description":"Recursive Monthly Description",
                                "duration":3,
                                "location_id":"0",
                                "contact_person":"Demo Demo",
                                "contact_email":"demo@demo.com",
                                "contact_number":"9876543210",
                                "scheduled_for":0,
                                "role_name":"All",
                                "status":"active",
                                "type":"recursive",
                                "created_at":"2018-12-20 22:23:22",
                                "updated_at":"2019-01-07 21:42:50",
                                "wellness_id":1,
                                "wellness_title":"Accessible AetnaGet Active Program"
                            },
                            {
                                "title":"Recursive Monthly",
                                "start":"2019-05-02T11:52:00",
                                "end":"2019-05-02T12:52:00",
                                "eventdate":"2nd To 2nd Of Every Month",
                                "eventtime":"",
                                "id":13,
                                "description":"Recursive Monthly Description",
                                "duration":3,
                                "location_id":"0",
                                "contact_person":"Demo Demo",
                                "contact_email":"demo@demo.com",
                                "contact_number":"9876543210",
                                "scheduled_for":0,
                                "role_name":"All",
                                "status":"active",
                                "type":"recursive",
                                "created_at":"2018-12-20 22:23:22",
                                "updated_at":"2019-01-07 21:42:50",
                                "wellness_id":1,
                                "wellness_title":"Accessible AetnaGet Active Program"
                            },
                            {
                                "title":"Recursive Weekly",
                                "start":"2019-04-06",
                                "eventdate":"Every Saturday",
                                "eventtime":"",
                                "id":15,
                                "description":"Recursive Weekly Description",
                                "duration":2,
                                "location_id":"3",
                                "contact_person":"Demo Demo",
                                "contact_email":"demo@demo.com",
                                "contact_number":"9876543210",
                                "scheduled_for":1,
                                "role_name":"HR",
                                "status":"active",
                                "type":"recursive",
                                "created_at":"2018-12-20 22:29:09",
                                "updated_at":"2019-01-08 09:15:42",
                                "wellness_id":1,
                                "wellness_title":"Accessible AetnaGet Active Program"
                            },
                            {
                                "title":"Recursive Weekly",
                                "start":"2019-04-13",
                                "eventdate":"Every Saturday",
                                "eventtime":"",
                                "id":15,
                                "description":"Recursive Weekly Description",
                                "duration":2,
                                "location_id":"3",
                                "contact_person":"Demo Demo",
                                "contact_email":"demo@demo.com",
                                "contact_number":"9876543210",
                                "scheduled_for":1,
                                "role_name":"HR",
                                "status":"active",
                                "type":"recursive",
                                "created_at":"2018-12-20 22:29:09",
                                "updated_at":"2019-01-08 09:15:42",
                                "wellness_id":1,
                                "wellness_title":"Accessible AetnaGet Active Program"
                            },
                            {
                                "title":"Recursive Weekly",
                                "start":"2019-04-20",
                                "eventdate":"Every Saturday",
                                "eventtime":"",
                                "id":15,
                                "description":"Recursive Weekly Description",
                                "duration":2,
                                "location_id":"3",
                                "contact_person":"Demo Demo",
                                "contact_email":"demo@demo.com",
                                "contact_number":"9876543210",
                                "scheduled_for":1,
                                "role_name":"HR",
                                "status":"active",
                                "type":"recursive",
                                "created_at":"2018-12-20 22:29:09",
                                "updated_at":"2019-01-08 09:15:42",
                                "wellness_id":1,
                                "wellness_title":"Accessible AetnaGet Active Program"
                            },
                            {
                                "title":"Recursive Weekly",
                                "start":"2019-04-27",
                                "eventdate":"Every Saturday",
                                "eventtime":"",
                                "id":15,
                                "description":"Recursive Weekly Description",
                                "duration":2,
                                "location_id":"3",
                                "contact_person":"Demo Demo",
                                "contact_email":"demo@demo.com",
                                "contact_number":"9876543210",
                                "scheduled_for":1,
                                "role_name":"HR",
                                "status":"active",
                                "type":"recursive",
                                "created_at":"2018-12-20 22:29:09",
                                "updated_at":"2019-01-08 09:15:42",
                                "wellness_id":1,
                                "wellness_title":"Accessible AetnaGet Active Program"
                            },
                            {
                                "title":"Recursive Weekly",
                                "start":"2019-05-04",
                                "eventdate":"Every Saturday",
                                "eventtime":"",
                                "id":15,
                                "description":"Recursive Weekly Description",
                                "duration":2,
                                "location_id":"3",
                                "contact_person":"Demo Demo",
                                "contact_email":"demo@demo.com",
                                "contact_number":"9876543210",
                                "scheduled_for":1,
                                "role_name":"HR",
                                "status":"active",
                                "type":"recursive",
                                "created_at":"2018-12-20 22:29:09",
                                "updated_at":"2019-01-08 09:15:42",
                                "wellness_id":1,
                                "wellness_title":"Accessible AetnaGet Active Program"
                            },
                            {
                                "title":"Recursive Weekly",
                                "start":"2019-05-11",
                                "eventdate":"Every Saturday",
                                "eventtime":"",
                                "id":15,
                                "description":"Recursive Weekly Description",
                                "duration":2,
                                "location_id":"3",
                                "contact_person":"Demo Demo",
                                "contact_email":"demo@demo.com",
                                "contact_number":"9876543210",
                                "scheduled_for":1,
                                "role_name":"HR",
                                "status":"active",
                                "type":"recursive",
                                "created_at":"2018-12-20 22:29:09",
                                "updated_at":"2019-01-08 09:15:42",
                                "wellness_id":1,
                                "wellness_title":"Accessible AetnaGet Active Program"
                            },
                            {
                                "title":"Recursive Monthly Date range",
                                "start":"2019-04-02T11:21:13",
                                "end":"2019-04-04T11:21:13",
                                "eventdate":"2nd To 4th Of Every Month",
                                "eventtime":"",
                                "id":17,
                                "description":"Recursive Monthly Date range Description",
                                "duration":0,
                                "location_id":"0",
                                "contact_person":"Demo Demo",
                                "contact_email":"demo@demo.com",
                                "contact_number":"9876543210",
                                "scheduled_for":0,
                                "role_name":"All",
                                "status":"active",
                                "type":"recursive",
                                "created_at":"2018-12-24 21:54:55",
                                "updated_at":"2018-12-24 21:54:55",
                                "wellness_id":1,
                                "wellness_title":"Accessible AetnaGet Active Program"
                            },
                            {
                                "title":"Recursive Monthly Date range",
                                "start":"2019-05-02T11:21:13",
                                "end":"2019-05-04T11:21:13",
                                "eventdate":"2nd To 4th Of Every Month",
                                "eventtime":"",
                                "id":17,
                                "description":"Recursive Monthly Date range Description",
                                "duration":0,
                                "location_id":"0",
                                "contact_person":"Demo Demo",
                                "contact_email":"demo@demo.com",
                                "contact_number":"9876543210",
                                "scheduled_for":0,
                                "role_name":"All",
                                "status":"active",
                                "type":"recursive",
                                "created_at":"2018-12-24 21:54:55",
                                "updated_at":"2018-12-24 21:54:55",
                                "wellness_id":1,
                                "wellness_title":"Accessible AetnaGet Active Program"
                            }

                        ],
                config: {
                    /*'weekends': false,*/
                    defaultView: 'month',
                    displayEventTime: false,
                    editable: false,
                    noEventsMessage: "Calendaer Entries Not Available",
                    eventClick: (event) => {
                        console.log(event);
                        this.selected = event;
                    },
                    header: {
                        left: 'prev,next',
                        /*left: '',*/
                        center: 'title',
                        right: 'month,listMonth',
                    },
                    buttonText: {
                        /*'prev': 'Previous',
                        'next': 'Next',*/
                        'month': 'Month',
                        'listMonth': 'List',
                    }
                },
            }
        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/calendar.vue